/*

   Config files for the PRODUCTION environment.

*/
import firebase from 'firebase/app'
import 'firebase/functions'

const serverLoc = 'https://smartkidsmarket.com/'
const emailDomain = 'smartkidsmarket.com'


const prodFirebaseConfig = {
  apiKey: 'AIzaSyCZ2XyTMDto0dkciCqx1XuaCq1uDFdrOFM',
  authDomain: 'samanthas-art.firebaseapp.com',
  databaseURL: 'https://samanthas-art.firebaseio.com',
  projectId: 'samanthas-art',
  storageBucket: 'samanthas-art.appspot.com',
  messagingSenderId: '119773800176'
}

const prodRecaptchaSiteKey = '6LdzNXMUAAAAABvAV_9w2xpkXuFfsUun-MiFy0y5'
const stripePublishableKey = 'pk_live_KmJxbGAHqi4au2oTt4Lkok70'

let theFunctions = null
function getFunctions () {
  if (!theFunctions) {
    theFunctions = firebase.functions()
  }
  return theFunctions
}
export default {
  'serverLoc': serverLoc,
  'maxFileSize': 1024 * 1024 * 10, // 10MB,
  'firebaseConfig': prodFirebaseConfig,
  'recaptchaSiteKey': prodRecaptchaSiteKey,
  'getFunctions': getFunctions,
  'stripePublishableKey': stripePublishableKey,
  'emailDomain': emailDomain

}
